export default __webpack_public_path__ + "static/media/copy.6a33660c.svg";